module.exports = __webpack_public_path__ + "img/pr-2.2960ef5f.png";